import useManageProjectStore from '../../../../../../stores/manageProject/useManageProjectStore'
import { OfficerType } from './officerType'
import * as Constants from '../../../../../../constants/constants'
import useAppFolderAndTabStore from '../../../../../../stores/appFolderAndTab/appFolderAndTabStore'
import CloseProjectByAdmin from '../../../page/requestNewProject/closeProjectByAdmin/closeProjectByAdmin'
import SignREC1 from '../../../page/sign/signMemoMessage/signREC1'
import SignREC2 from '../../../page/sign/signMemoMessage/signREC2'
import SignRepresentREC1 from '../../../page/signRepresent/signRepresentMemoMessage/signRepresentREC1'
import SignRepresentREC2 from '../../../page/signRepresent/signRepresentMemoMessage/signRepresentREC2'
import Memomessage from '../../../page/memoMessage/closeProjectByAdmin/memoMessage'
import useCheckPermission from '../../../../../../utilities/checkPermission'
import submittedStep from '../../../../../../constants/submittedStep'

const OfficerView: React.FC<OfficerType> = (props) => {
    const { callbackSaveComplete } = props
    const appFolderAndTabStore = useAppFolderAndTabStore()
    const manageProjectStore = useManageProjectStore()
    const checkPermission = useCheckPermission()

    const renderPage = () => {
        const tabID = appFolderAndTabStore?.tabSelected?.id
        const REC = manageProjectStore?.projectData?.irbType
        let isNotDisableTestResult = false
        switch (REC) {
            case 1:
                switch (tabID) {
                    case Constants.menuTab.tab1Chairman.id:
                        // tab1Chairman <div> ตรวจสอบเอกสาร REC1</div>
                        if (checkPermission.isUserChairman()) {
                            isNotDisableTestResult = manageProjectStore?.projectData?.stepID === submittedStep.synthesis
                        }
                        return (
                            <CloseProjectByAdmin
                                projectData={manageProjectStore?.projectData ?? undefined}
                                onSaveComplete={callbackSaveComplete}
                            />
                        )

                    case Constants.menuTab.tab1Committee.id:
                        if (checkPermission.isUserCommittee()) {
                            isNotDisableTestResult = manageProjectStore?.projectData?.stepID === submittedStep.synthesis
                        }
                        return (
                            <CloseProjectByAdmin
                                projectData={manageProjectStore?.projectData ?? undefined}
                                onSaveComplete={callbackSaveComplete}
                            />
                        )

                    case Constants.menuTab.tab21.id:
                        return (
                            // <div>ยื่นเอกสารโครงการ ปิดโครงการ</div>
                            <CloseProjectByAdmin
                                projectData={manageProjectStore?.projectData ?? undefined}
                                onSaveComplete={callbackSaveComplete}
                            />
                        )

                    case Constants.menuTab.tab11.id:
                        return (
                            // <div>ออกใบบันทึกข้อความ ปิดโครงการ</div>

                            <Memomessage
                                projectData={manageProjectStore?.projectData ?? undefined}
                                onSaveComplete={callbackSaveComplete}
                            />
                        )

                    case Constants.menuTab.tab9.id:
                        return <SignREC1 callbackSaveComplete={callbackSaveComplete} />

                    case Constants.menuTab.tab10.id:
                        return <SignRepresentREC1 callbackSaveComplete={callbackSaveComplete} />
                    default:
                        return <></>
                }

            case 2:
                switch (tabID) {
                    case Constants.menuTab.tab1Chairman.id:
                        // tab1
                        // return <div> ตรวจสอบเอกสาร REC2</div>
                        if (checkPermission.isUserChairman()) {
                            isNotDisableTestResult = manageProjectStore?.projectData?.stepID === submittedStep.synthesis
                        }
                        return (
                            <CloseProjectByAdmin
                                projectData={manageProjectStore?.projectData ?? undefined}
                                onSaveComplete={callbackSaveComplete}
                            />
                        )

                    case Constants.menuTab.tab1Committee.id:
                        if (checkPermission.isUserCommittee()) {
                            isNotDisableTestResult = manageProjectStore?.projectData?.stepID === submittedStep.synthesis
                        }
                        return (
                            <CloseProjectByAdmin
                                projectData={manageProjectStore?.projectData ?? undefined}
                                onSaveComplete={callbackSaveComplete}
                            />
                        )

                    case Constants.menuTab.tab21.id:
                        return (
                            // <div>ยื่นเอกสารโครงการ ปิดโครงการ</div>
                            <CloseProjectByAdmin
                                projectData={manageProjectStore?.projectData ?? undefined}
                                onSaveComplete={callbackSaveComplete}
                            />
                        )

                    case Constants.menuTab.tab11.id:
                        return (
                            // <div>ออกใบบันทึกข้อความ ปิดโครงการ</div>

                            <Memomessage
                                projectData={manageProjectStore?.projectData ?? undefined}
                                onSaveComplete={callbackSaveComplete}
                            />
                        )

                    case Constants.menuTab.tab9.id:
                        return <SignREC2 callbackSaveComplete={callbackSaveComplete} />

                    case Constants.menuTab.tab10.id:
                        return <SignRepresentREC2 callbackSaveComplete={callbackSaveComplete} />
                    default:
                        return <div></div>
                }

            default:
                return <div></div>
        }
    }
    return <> {renderPage()} </>
}
const Officer: React.FC<OfficerType> = (props) => {
    return <OfficerView {...props} />
}
export default Officer
